import React from 'react';
import { View, StyleSheet, Modal, ActivityIndicator } from 'react-native';
import { useTheme } from 'react-native-paper';

export default function Loader() {
  const theme = useTheme();
  return (
    // <Modal visible={true} transparent={true} animationType={'none'} style={styles.modal}>
    <View style={styles.container}>
      <ActivityIndicator size={'large'} color={theme.colors.text} />
    </View>
    // </Modal>
  );
}
const styles = StyleSheet.create({
  modal: {
    margin: 0,
  },
  container: {
    width: '100%',
    height: '90%',
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
